module.exports = __webpack_public_path__ + "img/0-02-0a-a0e9097d927f2d02be8d50c346c990bedb0b0a63f2560051ee8d22378b9670eb_7fec391e.76a41f12.jpg";